/**
 * Content Editor Routes
 * legacy app: canActivate: [AuthGuard, RoleGuard, VendorRoleGuard]
 * data: { checkRoleFor: 'UHCI_Admin' }
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const ContentEditor = lazy(() =>
  import('@src/apps/ContentEditor/ContentEditor').then(m => ({ default: m.ContentEditor }))
);
const OnBoarding = lazy(() => import('@src/apps/OnBoarding/OnBoarding').then(m => ({ default: m.OnBoarding })));
const Faq = lazy(() =>
  import('@src/apps/ContentEditor/Faq/faq-content-editor-connected')
);
const NotificationBannerManager = lazy(() =>
  import('@src/apps/ContentEditor/NotificationBannerManager/NotificationBannerManager-connected')
);

export const contentEditorRoutes: RouteConfig[] = [
  {
    path: 'content-editor',
    component: ContentEditor,
    guards: ['auth', 'role', 'vendor'],
    data: {
      title: 'Content Editor',
      breadcrumb: 'Knowledge Center Manager',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Admin',
    },
  },
  {
    path: 'content-editor/KnowledgeCenterEditor',
    component: ContentEditor,
    guards: ['auth', 'role', 'vendor'],
    data: {
      title: 'Content Editor',
      breadcrumb: 'Knowledge Center Manager',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Admin',
    },
  },
  {
    path: 'content-editor/onboarding-content-editor',
    component: OnBoarding,
    guards: ['auth', 'role', 'vendor'],
    data: {
      title: 'Onboarding Content Editor',
      breadcrumb: 'Onboarding Content Editor',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Admin',
    },
  },
  {
    path: 'content-editor/MainNavigationMenu/:id',
    component: OnBoarding,
    guards: ['auth', 'role', 'vendor'],
    data: {
      title: 'Main Navigation Menu',
      breadcrumb: 'Main Navigation Menu',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Admin',
    },
  },
  {
    path: 'content-editor/notification-banner-manager',
    component: NotificationBannerManager,
    guards: ['auth', 'role', 'vendor'],
    data: {
      title: 'Notification Banner Manager',
      breadcrumb: 'Notification Banner Manager',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Admin',
    },
  },
  {
    path: 'content-editor/faq-documentation',
    component: Faq,
    guards: ['auth', 'role', 'vendor'],
    data: {
      title: 'FAQ Documentation',
      breadcrumb: 'FAQ Documentation',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Admin',
    },
  },
];

